import { Link } from "react-router-dom";
import { getHotPosts, getPostsByCategory } from "@/lib/content";

export default function HotBoard() {
  const hot = getHotPosts(5);
  const sweet = getPostsByCategory("xiaotiangua").slice(0, 2);

  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <div className="flex items-end justify-between">
              <div>
                <p className="mb-2 flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600">
                  <span className="h-1 w-6 rounded-full bg-primary-500"></span>
                  HOT BOARD
                </p>
                <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
                  爆笑高能榜
                </h2>
              </div>
              <Link
                to="/category/baoxiao"
                className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-700"
              >
                完整榜单 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="mt-4 rounded-xl2 border border-background-200 bg-background-50 px-5 py-2">
              {hot.map((post, index) => (
                <Link
                  key={post.id}
                  to={`/post/${post.id}`}
                  className="group flex cursor-pointer items-center gap-4 border-b border-background-200 py-4 last:border-b-0"
                >
                  <span
                    className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-base font-bold ${
                      index === 0
                        ? "bg-accent-500 text-foreground-950"
                        : index <= 2
                          ? "bg-primary-100 text-primary-700"
                          : "bg-background-100 text-foreground-500"
                    }`}
                  >
                    {index + 1}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block truncate text-sm font-medium text-foreground-950 transition-colors group-hover:text-primary-700 md:text-[15px]">
                      {post.title}
                    </span>
                    <span className="mt-1 block text-xs text-foreground-500">{post.excerpt}</span>
                  </span>
                </Link>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="flex items-end justify-between">
              <div>
                <p className="mb-2 flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-secondary-600">
                  <span className="h-1 w-6 rounded-full bg-secondary-500"></span>
                  SWEET MOMENTS
                </p>
                <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
                  小甜瓜时刻
                </h2>
              </div>
              <Link
                to="/category/xiaotiangua"
                className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-secondary-700"
              >
                全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="mt-4 space-y-4">
              {sweet.map((post) => (
                <Link
                  key={post.id}
                  to={`/post/${post.id}`}
                  className="group flex cursor-pointer gap-4 rounded-xl2 border border-background-200 bg-background-50 p-4 transition-colors hover:border-secondary-300"
                >
                  <span className="h-20 w-24 shrink-0 overflow-hidden rounded-lg bg-background-200 md:h-24 md:w-28">
                    <img
                      src={post.cover}
                      alt={post.title}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block text-sm font-medium leading-snug text-foreground-950 transition-colors group-hover:text-secondary-700">
                      {post.title}
                    </span>
                    <span className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                      {post.excerpt}
                    </span>
                  </span>
                </Link>
              ))}
              <div className="rounded-xl2 border border-secondary-200 bg-secondary-50 px-5 py-4">
                <p className="flex items-center gap-2 text-sm font-medium text-secondary-800">
                  <i className="ri-heart-3-line"></i>
                  小甜瓜栏目 · 每天一条轻甜
                </p>
                <p className="mt-2 text-xs leading-relaxed text-secondary-900/80">
                  不吵不闹，慢慢看会不自觉笑出来，适合睡前放松的时候随手点开。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}